import {AfterViewInit, Component, Inject, Injector, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MatDialog, MatDrawer, MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import {Observable} from 'rxjs/Observable';
import {merge} from 'rxjs/observable/merge';
import {of as observableOf} from 'rxjs/observable/of';
import {catchError} from 'rxjs/operators/catchError';
import {map} from 'rxjs/operators/map';
import {startWith} from 'rxjs/operators/startWith';
import {switchMap} from 'rxjs/operators/switchMap';
import {HttpClient} from "@angular/common/http";
import {INJECTION_MODULE_TOKEN, InjectionModuleConfig, MOCK_HISTORIES} from "../exports";
import {FormControl} from "@angular/forms";
import {
  DrawerDetails,
  HistroyResponse,
  ResponseHistoryVacations,
  VacationBasicVO,
  ValidationVacation
} from "../InjectionVO";
import * as moment from "moment";
import {Subject} from "rxjs/Subject";
import {environment} from "../../../../environments/environment";
import {UploadFileComponent} from "../upload-file/upload-file.component";
import {AuthService} from "../../../auth/services/auth.service";
import {VacationAndBreak} from '../../vacationAndBreak';
import {Router} from '@angular/router';
import {RoleService} from '../../../service/RoleService';
import {Subscription} from 'rxjs/Subscription';
declare const window: any;
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HistoryComponent implements OnInit, AfterViewInit {
  displayedColumns = ['select', 'fullName', 'userName', 'dateFiche', 'motif', 'numberOfInjectionHours',
    'vstart1', 'vend1',
    'vstart2', 'vend2',
    'vstart3', 'vend3',
    'vstart4', 'vend4',
    'pstart1', 'pend1',
    'pstart2', 'pend2',
    'timezone', 'tl' , 'status'];
  dataSource = new MatTableDataSource<any>([]);
  selection = new SelectionModel<any>(true, []);

  exampleDatabase: any | null;
  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  isHistory = false;
  searchItem = '';
  findHistorySubscription: Subscription;


  validationVacation: ValidationVacation = {decision: null, injectionParamVos: [], motifReject: null};

  toppings = new FormControl();

  toppingList = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];

  status = new FormControl();

  statusList = ['APPROVED', 'REJECTED', 'PENDING'];
  searchControl = new FormControl('');


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('drawer') drawer: MatDrawer;

  constructor(private http: HttpClient, public dialog: MatDialog, private authService: AuthService, private roleService: RoleService,
              public route: Router, @Inject("inject-config") private config: InjectionModuleConfig, private auth: AuthService) {
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    //this.dataSource.paginator = this.paginator
  }

  ngOnInit() {
    this.isHistory = this.route.url === '/injections/hist';
    if(this.auth.hasRole("ROLE_TL_MYSHIFT2") || this.isHistory || (!this.authService.isDelegate && (this.roleService.isOps || this.roleService.isBUM))) {
      this.displayedColumns = this.displayedColumns.filter(e => e !== 'select');
    }
    if(!this.auth.hasRole("ROLE_DIRECTOR_MYSHIFT2")) {
      this.displayedColumns = this.displayedColumns.filter(e => e !== 'numberOfInjectionHours');
    }

    this.exampleDatabase = Observable.of(this.dataSource.data)

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    this.status.valueChanges.subscribe(() => {
      if (this.status.value.length) {
        this.findHistory();
      }
    })
    this.selection.onChange.subscribe(() => {
      this.drawer.toggle(this.selection.selected.length > 0);
      const selections: any = this.selection.selected;
      this.validationVacation.injectionParamVos = selections.map((row) => {
        if (!this.disableRow(row)){
          const v: ResponseHistoryVacations = typeof row == "object" ? row : JSON.parse(row) as ResponseHistoryVacations;
          console.log({v, row, isObject: (typeof row == "object"), oo: {
              date: v.dateFiche,
              etat: v.etat,
              id: v.id
            }
          })
          return {
            date: v.dateFiche,
            etat: v.etat,
            id: v.id
          }
        }

      });
    })
    setTimeout(() => {
      this.status.setValue(["PENDING"]);
    }, 5e2)
    this.searchControl.valueChanges.pipe(
      debounceTime(300),           // ⏱️ attendre 300ms après la dernière touche
      distinctUntilChanged()       // 🧠 ne pas appeler si la même valeur est tapée
    ).subscribe(value => {
      this.searchItem = value;
      this.paginator.pageIndex = 0; // reset page
      this.findHistory();          // appel unique après stabilisation
    });
    //this.getHistories("dateFiche","",0,7);
  }

  isSelected(row) {
    return this.selection.isSelected(JSON.stringify(row))
  }
  toggleSelect(row) {
    if(!this.auth.hasRole("ROLE_TL_MYSHIFT2") && !this.roleService.isOps && !this.roleService.isBUM) {
      this.selection.toggle(JSON.stringify(row))
    }
  }
  findHistory() {
    this.dataSource.data = []
    if (this.findHistorySubscription)
      this.findHistorySubscription.unsubscribe();
    this.findHistorySubscription = merge(this.sort.sortChange, this.paginator.page, this.paginator.pageSize)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.getHistories(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize);
        }),
        map((data: HistroyResponse) => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.isSelectedAll = false;

          return data;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe((data: HistroyResponse) => {
      let _data: Array<any> = this.dataSource.data
      // _data = _data.concat(this.mapDataVO(data.content || []));
      this.dataSource.data = this.mapDataVO(data.content || []);
      setTimeout(() => {
        this.paginator.length = data.totalElements;
        this.resultsLength = data.totalElements;
        console.log(data.totalElements)
      }, 1e2)
    });
  }

  mapDataVO(data: ResponseHistoryVacations[]) {
    return data.reverse().map((row: ResponseHistoryVacations) => {
      const vo = row.vo ? (JSON.parse(row.vo) as VacationAndBreak) : new VacationAndBreak();
      console.log("vo : ",vo);
      return {

        ...row,
        vstart1: vo.vacations[0] ? this.HHmmDate(vo.vacations[0].debut) : '-',
        vend1: vo.vacations[0] ? this.HHmmDate(vo.vacations[0].fin) : '-',

        vstart2: vo.vacations[1] ? this.HHmmDate(vo.vacations[1].debut) : '-',
        vend2: vo.vacations[1] ? this.HHmmDate(vo.vacations[1].fin) : '-',

        vstart3: vo.vacations[2] ? this.HHmmDate(vo.vacations[2].debut) : '-',
        vend3: vo.vacations[2] ? this.HHmmDate(vo.vacations[2].fin) : '-',

        vstart4: vo.vacations[3] ? this.HHmmDate(vo.vacations[3].debut) : '-',
        vend4: vo.vacations[3] ? this.HHmmDate(vo.vacations[3].fin) : '-',
        pstart1: vo.pauses[0] ? this.HHmmDate(vo.pauses[0].debut) : '-',
        pend1: vo.pauses[0] ? this.HHmmDate(vo.pauses[0].fin) : '-',

        pstart2: vo.pauses[1] ? this.HHmmDate(vo.pauses[1].debut) : '-',
        pend2: vo.pauses[1] ? this.HHmmDate(vo.pauses[1].fin) : '-',
      }
    })
  }

  HHmmDate(v) {
    return moment(v).format('HH:mm')
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected(isAll:boolean) {
    console.log("from : ",isAll);
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  getHistories(sort: string, order: string, page: number, size: number): Observable<any> {
    const status = (this.status.value as Array<string>).join(',');
    let requestUrl = `${environment.api.myshiftUrl}/injection/v2/all2?page=${page.toString()}&size=${size.toString()}&status=${status}`;
    if (this.searchItem && this.searchItem.trim() != '' && this.searchItem.length > 1)
      requestUrl = `${environment.api.myshiftUrl}/injection/v2/all2?page=${page.toString()}&size=${size.toString()}&status=${status}&filter=${this.searchItem}`;
    return this.isHistory ? this.http.post(requestUrl, []) : this.http.post(requestUrl, this.authService.listDelegation);
  }

  eventDrawer(ev: DrawerDetails<any>) {
    if (ev.event == "CLOSE") {
      this.validationVacation.decision = null
      this.drawer.close();
      this.selection.clear();
      this.isSelectedAll = false;
    }
    if (ev.event == "OPEN") {
      this.validationVacation.decision = null
    }
    if (ev.event == "POST_MESSAGE") {

    }

    if (ev.event == "END") {
      this.validationVacation.decision = null
      this.drawer.close();
      this.selection.clear();
      this.findHistory();
      this.isSelectedAll = false;
    }
  }

  refresh() {
    this.isRateLimitReached = false;
    this.findHistory();
  }

  async  uploadFile(files: File[]) {
    const [file] = Array.from(files);
    (file as any).arrayBuffer().then((arrayBuf) => {
      window.queueMicrotask(() => {
        const wb = window.XLSX.read(arrayBuf);
        this.dialog.open(UploadFileComponent, {
          data: {rows: this.xlsxToJson(wb), source: wb}
        })
      })
    })
  }
  xlsxToJson(worksheet) {
    /*const data = worksheet.SheetNames.map((e, i) => {
      const rows = window.XLSX.utils.sheet_to_row_object_array(worksheet.Sheets[e], {raw: false});
      return rows.map(r => {
        return {...r, sheet: e}
      })
    })*/
    return [];
  }

  calculateNumberOfInjectionHours(element:any) {
    let total : number = 0;
    const formatVacation = (d, h) => moment(`${d} ${h}`).format("YYYY-MM-DD HH:mm")
    const date = moment(new Date()).format("YYYY-MM-DD");
    if (element.vstart1 && element.vend1)
      total = total + this.calculateDiffTwoDatesInMinuteHours(new Date(formatVacation(date,element.vstart1)),new Date(formatVacation(date,element.vend1)))


    if (element.vstart2 && element.vend2)
      total = total + this.calculateDiffTwoDatesInMinuteHours(new Date(formatVacation(date,element.vstart2)),new Date(formatVacation(date,element.vend2)))

    if (element.vstart3 && element.vend3)
      total = total + this.calculateDiffTwoDatesInMinuteHours(new Date(formatVacation(date,element.vstart3)),new Date(formatVacation(date,element.vend3)))


    if (element.vstart4 && element.vend4)
      total = total + this.calculateDiffTwoDatesInMinuteHours(new Date(formatVacation(date,element.vstart4)),new Date(formatVacation(date,element.vend4)))

    return total==0|| isNaN(total)?0:total;
  }

  private calculateDiffTwoDatesInMinuteHours(startDate: Date, endDate: Date) {
    let hourDiff = endDate.getTime() - startDate.getTime(); //in ms
    let hDiff = Math.floor(Math.floor(hourDiff / 3600 / 1000)); //in hours
    return hDiff==0|| isNaN(hDiff)?0:hDiff;
  }

  disableRow(row:any){
    return row && (row.status == 'APPROVED' || row.status == 'CANCELED' || row.status == 'REJECTED');

  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  isSelectedAll :boolean = false;
  masterToggle() {
    if(this.validationVacation.decision) return;
    this.isSelectedAll = !this.isSelectedAll;
    this.selection.clear();
    if (this.isSelectedAll)
      this.dataSource.data
        // .filter(row=>  row && row.status == this.status.value[0])
        .forEach(row => {
          if (!this.disableRow(row))
            this.selection.select(JSON.stringify(row))
        });

    /* this.isAllSelected(true) ?
       this.selection.clear() :
       this.selection = new SelectionModel<any>(true, []);
       this.dataSource.data
        // .filter(row=>  row && row.status == this.status.value[0])
         .forEach(row => {
           if (!this.disableRow(row))
             this.selection.select(JSON.stringify(row))
       });*/
    this.drawer.toggle(!!this.selection.selected.length);
  }

  selectRow(event,row) {
    if (event.checked)
      this.selection.select(JSON.stringify(row))
    else
      this.selection.deselect(JSON.stringify(row));
    if (this.selection.selected.length == 0)
      this.isSelectedAll = false;
    else if (this.selection.selected.length == this.dataSource.data.length)
      this.isSelectedAll = true;
  }
  searchInjection() {
    this.findHistory();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/injection/history/history.component.ts